import { TextField } from '@material-ui/core'

export const DataPicker = (props) => {

    return (
        <TextField
            type="date"
            InputLabelProps={{
                shrink: true,
            }}
            {...props}
        />)
}

export const TimePicker = (props) => {

    return (
        <TextField
            type="time"
            InputLabelProps={{
                shrink: true,
            }}
            {...props}
        />)
}
